import request from '@/axios/request'

export function getUserCourse(query) {
    return request({
        url: '/business/web/userCourse/queryUserCourse',
        method: 'get',
        params: query
    })
}
export function getUserCourseCount(query) {
    return request({
        url: '/business/web/userCourse/queryUserCourseCount',
        method: 'get',
        params: query
    })
}
